import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import './Dashboard.css';

const UserDashboard = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const games = [
    {
      id: 'deductive',
      name: 'Deductive Challenge',
      description:
        'Complete the matrix by selecting appropriate symbols. No row or column should have similar symbols.',
      color: '#FF8A00',
      icon: '🧩',
    },
    {
      id: 'inductive',
      name: 'Inductive Challenge',
      description:
        'Find the rule followed in grid transformations and identify matching patterns.',
      color: '#FF8A00',
      icon: '🔍',
    },
    {
      id: 'switch',
      name: 'Switch Challenge',
      description:
        'Decode symbol patterns and find the correct output based on the input order.',
      color: '#FF8A00',
      icon: '🔄',
    },
    {
      id: 'grid',
      name: 'Grid Challenge',
      description:
        'Remember circle positions, check pattern symmetry, and mark circles in the correct order.',
      color: '#EF8354',
      icon: '⚡',
    },
    {
      id: 'motion',
      name: 'Motion Challenge',
      description:
        'Move colored blocks to create a path for the red ball to reach the black hole.',
      color: '#FF8A00',
      icon: '🎯',
    },
  ];

  const handlePlayGame = (gameId) => {
    const gameWindow = window.open(`/game/${gameId}`, '_blank');
    if (gameWindow) {
      gameWindow.focus();
    }
  };

  const handleLogout = async () => {
    try {
      await api.post('/user/logout');
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      logout();
      navigate('/');
    }
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div>
          <h1>Gaming Portal</h1>
          <p className="welcome-text">Welcome, {user?.name}!</p>
        </div>
        <div className="header-actions">
          <div className="user-info">
            <span className="user-name">{user?.name}</span>
            <span className="user-email">{user?.email}</span>
          </div>
          <button onClick={handleLogout} className="btn-secondary">
            Logout
          </button>
        </div>
      </header>

      <div className="dashboard-content">
        <div className="games-grid">
          {games.map((game) => (
            <div key={game.id} className="game-card">
              <div className="game-icon" style={{ backgroundColor: game.color }}>
                <span>{game.icon}</span>
              </div>
              <h3>{game.name}</h3>
              <p>{game.description}</p>
              <button
                onClick={() => handlePlayGame(game.id)}
                className="btn-play"
                style={{ backgroundColor: game.color }}
              >
                Play Game
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
